<template>
  <div>
    <el-upload :show-file-list="false" @change="change" :on-success="(file, fileList) => handler().imageSuccess(file, fileList)" :action="uploadDomain" :data="{ token: qiniuToken }" :before-upload="init().beforeUpload" class="avatar-uploader" >
      <div v-if="value[prop.key]" class="avatar">
        <span v-if="value[prop.key]">{{ value[prop.file_name] }}</span>
        <div class="del btn" @click.stop="value[prop.key] = '';value[prop.file_name] = ''">
          <i class="icon el-icon-close"/>
        </div>
      </div>
      <i v-else class="el-icon-plus avatar-uploader-icon">{{ label }}</i>
    </el-upload>
  </div>
</template>

<script>
import { imgDomain, uploadDomain } from '../../configs/env'
import { getQiniuToken } from '../../api/login';
export default{
  props: {
    label: {
      type: String,
      default: '照片',
    },
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
    prop: {
      type: Object,
      default: () => {
        return {
          key: 'avatar',
          file_name: 'file_name',
        }
      },
    },
  },
  data() {
    return {
      qiniuToken: '',
      imgDomain,
      uploadDomain,
    }
  },
  methods: {
    change(e){
      console.log(e)
    },
    init() {
      return {
        // 上传前置操作
        beforeUpload: async(file) => {
          if (this.qiniuToken) {
            return true
          }

          var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
          const extension =
            testmsg === "pdf" ||
            testmsg === "doc" ||
            testmsg === "docx" ||
            testmsg === "xls" ||
            testmsg === "xlsx" ||
            testmsg === "jpg" ||
            testmsg === "JPG" ||
            testmsg === "png" ||
            testmsg === "PNG" ||
            testmsg === "bpm" ||
            testmsg === "jpeg" ||
            testmsg === "BPM";

          if (!extension) {
            this.$message.warning('上传图片只能是pdf / doc / docx / xls / xlsx / jpg / jpeg / png / bpm格式!');
            this.qiniuToken = ''
            return false;
          }

          try {
            // 获取七牛云token
            const { status, data } = await getQiniuToken()
            if (status !== 200) return
            this.qiniuToken = data.token
            return data.token
          } catch (err) {
            this.$message('请求出错')
            return false
          }
        },
      }
    },
    handler() {
      return {
        // 图片上传成功回调
        imageSuccess: (file, fileList) => {
          console.log(file, fileList)
          this.$set(this.value, this.prop.file_name, fileList.name)
          this.$set(this.value, this.prop.key, file.key)
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-uploader{
  display: block;
  height: 100px;
  .avatar-uploader-icon{
    width: 100px;
    height: 100px;
    line-height: 100px;
    font-size: 16px;
  }
  .avatar{
    width: auto;
    height: 60px;
    img{
      width: auto;
      height: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/uploadFile.vue